import React from 'react';
import { Modal } from 'antd';
import './ImagePreviewModal.css';

const ImagePreviewModal = ({ visible, src, onClose }) => {
    const handleDownload = () => {
        if (src) {
            const link = document.createElement('a');
            link.href = src;
            link.download = `image_${Date.now()}.png`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    };

    const handleOpenInNewTab = () => {
        if (src) {
            window.open(src, '_blank');
        }
    };

    return (
        <Modal
            open={visible}
            onCancel={onClose}
            footer={null}
            width="90vw"
            style={{ top: 20 }}
            className="image-preview-modal"
            centered
            destroyOnClose
        >
            <div className="image-preview-container">
                <div className="image-preview-content">
                    {src && (
                        <img
                            src={src}
                            alt="预览图片"
                            className="preview-image"
                            onClick={(e) => e.stopPropagation()}
                        />
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default ImagePreviewModal; 